import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';

@Injectable()
export class BrightLocalService {
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*"
    })
  };

  batchUrl = 'https://vovs5a6lw4.execute-api.us-east-1.amazonaws.com/dev/bright-local';

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * {
   *   "success": true,
   *   "batch-id": 169210926
   *  }
   */
  createNewBatch(clientCode, locationKey, locationName) {
    return this.http.post(this.batchUrl, JSON.stringify({
      "type": "create-batch",
      "clientCode": clientCode,
      "locationKey": locationKey,
      "locationName": locationName,
      "env": environment.env
    }), this.httpOptions);
  }

  addUrlToBatch(url, batchId, clientCode, locationKey, locationName) {
    return this.http.post(this.batchUrl, JSON.stringify({
      "type": "add-url",
      "url": url,
      "batch-id": batchId,
      "clientCode": clientCode,
      "locationKey": locationKey,
      "locationName": locationName,
      "env": environment.env
    }), this.httpOptions);
  }

  commitBatch(batchId, clientCode, locationKey, locationName) {
    return this.http.post(this.batchUrl, JSON.stringify({
      "batch-id": batchId,
      "type": "commit",
      "clientCode": clientCode,
      "locationKey": locationKey,
      "locationName": locationName,
      "env": environment.env
    }), this.httpOptions);
  }

  getResults(batchId, clientCode, locationKey, locationName) {
    return this.http.post(this.batchUrl, JSON.stringify({
      "batch-id": batchId,
      "type": "get-results",
      "clientCode": clientCode,
      "env": environment.env,
      "locationKey": locationKey,
      "locationName": locationName
    }), this.httpOptions);
  }

  toggleReviewsAutoUpdate(clientCode, action: 'enable' | 'disable') {
    return this.http.post('https://agenda.storpug.com/v1/enable-reviews-auto-update', {
      "clientCode": clientCode,
      "env": environment.env,
      "action": action
    }, this.httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/bright-local.service.ts